import {
  collection,
  getDocs,
  query,
  limit,
  startAfter,
  QueryDocumentSnapshot,
  DocumentData,
  orderBy,
  getCountFromServer,
  where,
  OrderByDirection,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';
import { UserRole } from '@leedpulse-monorepo/enums';

async function getUsersFromRoles(
  offset: number,
  rolesConstraint: UserRole[],
  orderName: string,
  orderDirection: OrderByDirection,
  lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>
): Promise<{
  users: UserDoc[];
  lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData>;
  totalCollectionCount: number;
}> {
  try {
    const db = firestore;
    const usersCollection = collection(db, FirestoreCollections.users);
    const results = lastVisible
      ? await getDocs(
          query(
            usersCollection,
            where('role', 'in', rolesConstraint),
            orderBy(orderName, orderDirection),
            startAfter(lastVisible),
            limit(offset)
          )
        )
      : await getDocs(
          query(
            usersCollection,
            where('role', 'in', rolesConstraint),
            orderBy(orderName, orderDirection),
            limit(offset)
          )
        );

    const users: UserDoc[] = [];

    results.docs.forEach((doc) => {
      users.push(UserDoc.fromFirestore(doc));
    });

    const usersSnapshot = await getCountFromServer(
      query(usersCollection, where('role', 'in', rolesConstraint))
    );

    return {
      users,
      lastVisible: results.docs[results.docs.length - 1],
      totalCollectionCount: usersSnapshot.data().count ?? 0,
    };
  } catch (e) {
    console.error('error: ', e);
    throw new GetUsersFromRolesFailure();
  }
}

export class GetUsersFromRolesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUsersFromRoles;
